var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationLetter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "31px",
    viewBox: "0 0 31 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CB15D73D-75B2-4888-B5A5-91B0F62C1865") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.09487651,10.3041788 C3.23007715,10.1689782 3.41344858,10.0930233 3.60465116,10.0930233 L12.255814,10.0930233 C12.6539727,10.0930233 12.9767442,9.7702518 12.9767442,9.37209302 L12.9767442,2.1627907 C12.9767442,1.76463192 12.6539727,1.44186047 12.255814,1.44186047 L2.1627907,1.44186047 C1.76463192,1.44186047 1.44186047,1.76463192 1.44186047,2.1627907 L1.44186047,11.9571949 L3.09487651,10.3041788 Z M3.90327024,11.5348837 L1.23070489,14.2074491 C0.776544175,14.6616098 8.8817842e-16,14.3399547 8.8817842e-16,13.6976744 L8.8817842e-16,2.1627907 C8.8817842e-16,0.968314378 0.968314378,0 2.1627907,0 L12.255814,0 C13.4502903,0 14.4186047,0.968314378 14.4186047,2.1627907 L14.4186047,9.37209302 C14.4186047,10.5665693 13.4502903,11.5348837 12.255814,11.5348837 L3.90327024,11.5348837 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8711664,14.1637173 C12.730396,14.0229469 12.5021621,14.0229469 12.3613917,14.1637173 C12.2206214,14.3044877 12.2206214,14.5327216 12.3613917,14.673492 L14.1637173,16.4758176 C14.3044877,16.6165879 14.5327216,16.6165879 14.673492,16.4758176 L18.6386083,12.5107013 C18.7793786,12.3699309 18.7793786,12.141697 18.6386083,12.0009266 C18.4978379,11.8601562 18.269604,11.8601562 18.1288336,12.0009266 L14.4186047,15.7111556 L12.8711664,14.1637173 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Final",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.3_ShomreyHaderech_New",
    transform: "translate(-412.000000, -356.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(412.000000, 356.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#040B44",
    cx: 15.5,
    cy: 15.5,
    r: 15.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "message-square",
    transform: "translate(7.930233, 8.651163)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#F2F3F8",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "COLOR/-black",
    mask: "url(#mask-2)",
    fill: "#F2F3F8"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.441860, -1.441860)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 17.3023256,
    height: 17.3023256
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    stroke: "#F2F3F8",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationLetter);
export default __webpack_public_path__ + "static/media/NotificationLetter.45772ac6b3fc93b92a422dc73e76000a.svg";
export { ForwardRef as ReactComponent };